// Utility function to format amount to 2 decimal places
import moment from 'moment-timezone';
import { DEFAULT_CURRENCY } from '../config';

export const formatAmount = (amount, locale = 'en-US', currency = null, useGrouping = true, decimalPlaces = null) => {
    // Determine decimal places: If not provided, use 2 decimals only if needed
    const hasDecimals = amount % 1 !== 0; // Check if amount has decimal part
    const minDecimals = decimalPlaces !== null ? decimalPlaces : hasDecimals ? 2 : 0;
    const maxDecimals = decimalPlaces !== null ? decimalPlaces : hasDecimals ? 2 : 0;

    return new Intl.NumberFormat(locale, {
        style: currency ? 'currency' : 'decimal',
        currency: currency || undefined,
        useGrouping: useGrouping,
        minimumFractionDigits: minDecimals,
        maximumFractionDigits: maxDecimals
    }).format(amount);
};

export const formatString = (template, args, fallback = "") => {
    if (!template || !args) return template;
  
    return template.replace(/{([^{}]+)}/g, (match, key) => {
      // Check if the placeholder is a key in the `args` object
      const keys = key.split("."); // Support nested keys like "user.name"
      let value = args;
  
      for (const k of keys) {
        value = value?.[k];
        if (value === undefined) break;
      }
  
      return value !== undefined ? value : fallback; // Replace or fallback
    });
};

export const getErrorMessageByCode = (code) => {
    const errorMessages = {
      'ERR001': '未知错误发生，请联系系统管理员。',//系统异常，请联系后台
      // Add more error codes and messages here

      'FAP00001': '{0} 已被其他金主申购，请重新尝试抢单。',
      'FAP00006': '{0} 已在处理中，请重新尝试抢单。',
      'FAP00012': '银行账户余额不足。'
    };
  
    // Return the error message corresponding to the error code, or a default message
    return errorMessages[code] || errorMessages['ERR001'];
  };


const currencyToTimezone = {
    VND: 'Asia/Ho_Chi_Minh', // Vietnam Dong
};

/**
 * Convert UTC datetime to localized datetime based on currency code.
 * @param {string} utcDatetime - The UTC datetime string (e.g., "2025-01-15T12:00:00Z").
 * @param {string} currencyCode - The currency code (e.g., "VND").
 * @returns {string} The localized datetime string in "YYYY-MM-DD HH:mm:ss" format.
 */
export const convertUtcByCurrency = (utcDatetime, dtFormat = 'YYYY-MM-DD HH:mm:ss') => {
    const timezone = currencyToTimezone[DEFAULT_CURRENCY];

    if (!timezone) {
        throw new Error(`Unsupported currency code: ${DEFAULT_CURRENCY}`);
    }

    return moment.utc(utcDatetime).tz(timezone).format(dtFormat);
};
